import React, { useState } from 'react';
import { authContext } from '../Context/AuthContext';

const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState<any>();
    const [status, SetStatus] = useState<any>();

    const setAuthData = (data) => {
        if (data.isLoggedIn != undefined) {
            setAuth(data.isLoggedIn);
        }
        SetStatus(data.status)
    }

    return (
        <authContext.Provider value={{ loggedIn: auth, status: status, setAuthData }} >
            {children}
        </authContext.Provider>
    );

};
export default AuthProvider;